__turbopack_context__.v({
  "block": "Container-module-scss-module__7RNBUa__block",
  "container": "Container-module-scss-module__7RNBUa__container",
});
